import React from 'react';

/**
 * Official Core Spectators Brand Logo Component
 * Uses the authentic high-resolution official logo asset with Retina clarity and responsive scaling.
 */
const Logo = ({
  className = 'h-10 sm:h-12 w-auto',
  alt = 'Core Spectators - Software, Shopify & SaaS Engineering'
}) => {
  return (
    <picture>
      <source
        type="image/webp"
        srcSet="/images/Core_Spectators_1_1x.webp 1x, /images/Core_Spectators_1_2x.webp 2x"
      />
      <img
        src="/images/Core_Spectators_1.png"
        srcSet="/images/Core_Spectators_1_1x.webp 1x, /images/Core_Spectators_1_2x.webp 2x"
        alt={alt}
        width="220"
        height="48"
        style={{ aspectRatio: '220 / 48' }}
        className={`${className} object-contain transition-transform duration-200`}
        loading="eager"
        fetchPriority="high"
        decoding="async"
      />
    </picture>
  );
};

export default Logo;
